module.exports = __webpack_public_path__ + "img/icon_1.985b9596.png";